// extracted by mini-css-extract-plugin
export default {"link":"OrderFooter_link__19KNX","active":"OrderFooter_active__XaahF"};